<template>
  <v-container class="content">
    <ModalPadrao
      :showModal="deletePromotionModal"
      :ifSubheadingTop="true"
      :SubheadingTop="'Excluir a oferta?'"
      :ifIcon="true"
      :Icon="'delete'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="deletePromotionModal = false"
      @btnDois="cancelPromotion(promotionId)"
    ></ModalPadrao>
    <v-dialog width="1000px" v-model="promotionDetail">
      <v-card class="pa-3">
        <v-flex class="row mx-3 my-2">
          <v-layout align-center>
            <span class="title font-weight-medium">Detalhes Oferta</span>
            <v-spacer></v-spacer>
            <v-btn icon class="ma-0" @click="promotionDetail = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
        <v-divider></v-divider>
        <v-layout class="mx-3" row wrap>
          <v-flex xs12 md6 class="pt-4 px-2">
            <v-flex class="mb-2 text-justify">
              <span class="font-weight-medium subheading color">Título:</span>
              <span class="pl-2 subheading">Fim de Semana</span>
            </v-flex>
            <v-flex class="mb-2 text-justify">
              <span class="font-weight-medium subheading color"
                >Subtítulo:</span
              >
              <span class="pl-2 subheading"
                >Oferta durante o fim de semana</span
              >
            </v-flex>
            <v-flex class="mb-2 text-justify">
              <span class="font-weight-medium subheading color"
                >Descrição:</span
              >
              <span class="pl-2 subheading text-justify"
                >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Reprehenderit in, maxime tempora dolor quibusdam sapiente
                voluptatem aliquam iusto delectus beatae. Incidunt modi
                consequuntur sequi pariatur quisquam voluptates atque similique
                iste.</span
              >
            </v-flex>
            <v-flex xs12 class="row px-3">
              <v-flex class="mb-2 text-justify">
                <span class="font-weight-medium subheading color"
                  >Data Início:</span
                >
                <span class="pl-2 subheading">20/02/2020</span>
              </v-flex>
              <v-flex class="mb-2 text-justify">
                <span class="font-weight-medium subheading color"
                  >Data Fim:</span
                >
                <span class="pl-2 subheading">01/03/2020</span>
              </v-flex>
              <v-flex class="mb-2 text-justify">
                <span class="font-weight-medium subheading color"
                  >Tempo de duração:</span
                >
                <span class="pl-2 subheading">48h</span>
              </v-flex>
            </v-flex>
          </v-flex>
          <v-flex xs12 md6 class="pt-4 px-2 mb-2">
            <v-img
              style="height: 100%"
              class="mx-3"
              src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
            ></v-img>
          </v-flex>
          <v-flex xs12 class="mb-2 text-justify px-2">
            <span class="font-weight-medium subheading color">Clientes:</span>
            <span class="pl-2 pr-3 subheading"
              >Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui ab
              doloremque a laborum ipsam! Nobis, enim vitae temporibus
              similique, eaque possimus architecto quibusdam, ducimus magni
              voluptas sed aperiam maiores! Dolores!</span
            >
          </v-flex>
          <v-flex xs12 class="mb-3 px-2">
            <v-data-table
              :items="modelsPrices"
              item-key="model"
              :headers="headersModelsPrices"
              hide-default-footer
              class="elevation-1"
              no-data-text="Nenhum Modelo na oferta"
            >
              <template v-slot:items="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td class="text-xs-left">{{ props.item.model }}</td>
                  <td class="text-xs-left">{{ props.item.priceHour }}</td>
                  <td class="text-xs-left">{{ props.item.pricePack }}</td>
                  <td class="text-xs-left">{{ props.item.priceKm }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-card class="pa-3 pb-5">
      <v-flex class="row mx-3 my-2">
        <v-layout align-center>
          <span class="title font-weight-medium">Ofertas</span>
          <v-spacer></v-spacer>
          <v-btn class="ma-0 success white--text" @click="newPromotion = true"
            >Nova Oferta</v-btn
          >
        </v-layout>
      </v-flex>
      <v-divider class="mx-3"></v-divider>
      <v-flex class="row mx-3 mb-2">
        <v-btn
          @click="changePage('active')"
          :class="
            activePromotions ? 'colorApp white--text' : 'white grey--text'
          "
          class="ma-0 mr-2"
          >Habilitadas</v-btn
        >
        <v-btn
          @click="changePage('canceled')"
          :class="
            canceledPromotions ? 'colorApp white--text' : 'white grey--text'
          "
          class="ma-0"
          >Excluídas</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          placeholder="Filtrar"
          append-icon="search"
          hide-details
          class="pt-0 mb-1"
          v-model="search"
        ></v-text-field>
      </v-flex>

      <ModalNewPromotion
        :newPromotion="newPromotion"
        @close="(newPromotion = false), getPromotions()"
      ></ModalNewPromotion>
      <!-- <ModalEditPromotion
        v-if="editPromotion"
        :promotionId="promotionId"
        :editPromotion="editPromotion"
        :promotionType="promotionType"
        @close="editPromotion = false"
        @save="
          editPromotion = false;
          getPromotions();
        "
      ></ModalEditPromotion> -->

      <!-- Ofertas Ativas -->
      <v-flex class="col" v-if="activePromotions">
        <v-data-table
          no-data-text="Nenhuma oferta cadastrada"
          hide-default-footer
          :options.sync="paginationActive"
          :headers="headersActive"
          :items="promotionsActive"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.sub_title }}</td>

              <td
                v-if="
                  item.promotion_vehicle_model.length == 0 &&
                    item.promotion_client.length > 0
                "
              >
                R${{ item.promotion_client[0].activation_value | centsToReal }}
              </td>

              <td v-else>
                R${{
                  item.promotion_vehicle_model[0].package_value | centsToReal
                }}
              </td>

              <td>{{ item.type | typeFilter }}</td>

              <td>
                <v-text-field
                  hide-details
                  v-model="item.order"
                  type="number"
                  append-outer-icon="save"
                  @click:append-outer="saveOrder(item)"
                ></v-text-field>
              </td>

              <td class="pt-3">
                <!-- <ActionButton
                  message="Editar oferta"
                  icon="edit"
                  @onclick="
                    editPromotion = true;
                    promotionId = item.id;
                    promotionType = item.type;
                  "
                /> -->
                <ActionButton
                  message="Excluir oferta"
                  icon="delete"
                  color="error"
                  @onclick="
                    (deletePromotionModal = true), (promotionId = item.id)
                  "
                />
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="paginationActive.page"
            :length="paginationActive.totalPages"
            total-visible="9"
          >
          </v-pagination>
        </div>
      </v-flex>

      <!-- Ofertas Canceladas -->
      <v-flex class="col" v-if="canceledPromotions">
        <v-data-table
          no-data-text="Nenhuma oferta cadastrada"
          hide-default-footer
          :headers="headersCanceled"
          :items="promotionsCanceled"
          :options.sync="paginationCanceled"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.description }}</td>
            <td class="text-xs-right pr-4 px-0">
              <v-icon small>assignment</v-icon>
              <!-- detalhes -->
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="paginationCanceled.page"
            :length="paginationCanceled.totalPages"
          >
          </v-pagination>
        </div>
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>
import ModalNewPromotion from './ModalNewPromotion.vue';
// import ModalEditPromotion from './ModalEditPromotion.vue';
import PromotionController from '../../controllers/PromotionController';
import ModalPadrao from '../shared/ModalPadrao.vue';
import ActionButton from '../shared/ActionButtonsTemplate';
import moment from 'moment';

export default {
  components: {
    ActionButton,
    ModalNewPromotion,
    // ModalEditPromotion,
    ModalPadrao,
  },
  data() {
    return {
      // editPromotion: false,
      promotionController: new PromotionController(this.$resource),
      activePromotions: true,
      canceledPromotions: false,
      newPromotion: false,
      search: '',
      paginationActive: {},
      paginationCanceled: {},
      promotions: [],
      headersActive: [
        {
          text: 'Título',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Descrição', value: 'description', align: 'start' },
        {
          text: 'Valor ativação',
          value: 'promotion_client[0].activation_value',
          align: 'start',
        },
        { text: 'Tipo', value: 'type', align: 'start' },
        { text: 'Ordem', value: 'order', align: 'start' },
        {
          text: 'Ações',
          align: 'right',
          value: 'action',
          sortable: false,
          align: 'start',
        },
      ],
      promotionsActive: [],
      headersCanceled: [
        {
          text: 'Título',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'Descrição', value: 'description' },
        { text: 'Ações', align: 'right', value: 'action', sortable: false },
      ],
      promotionsCanceled: [],
      promotionDetail: false,
      headersModelsPrices: [
        {
          text: 'Modelo',
          align: 'left',
          value: 'model',
        },
        {
          text: 'Preço por Hora',
          align: 'left',
          value: 'priceHour',
        },
        {
          text: 'Preço no Pacote',
          align: 'left',
          value: 'pricePack',
        },
        {
          text: 'Preço por Km',
          align: 'left',
          value: 'priceKm',
        },
      ],
      modelsPrices: [
        {
          model: 'Modelo',
          priceHour: '20,00',
          pricePack: '25,00',
          priceKm: '1,00',
        },
        {
          model: 'Modelo2',
          priceHour: '21,00',
          pricePack: '24,00',
          priceKm: '13,00',
        },
      ],
      promotionId: 0,
      promotionType: '',
      deletePromotionModal: false,
    };
  },

  created() {
    this.getPromotions();
  },
  filters: {
    centsToReal(cents) {
      cents = (cents / 100).toFixed(2).replace('.', ',');
      return cents;
    },
    typeFilter(value) {
      switch (value) {
        case 'promotion':
          return 'Promoção';
        case 'package':
          return 'Pacote';
        case 'recurrent':
          return 'Recorrente';
        case 'loyalty':
          return 'Fidelidade';
        case 'wallet_hours':
          return 'Carteira de Horas';
      }
    },
  },

  methods: {
    saveOrder(value) {
      this.promotionController.updateOrder(value).then(
        res => this.$awn.success(res.message),
        err => {
          console.log(err);
        }
      );
    },
    getPromotions() {
      this.promotionController.get().then(
        promotions => {
          this.promotionsActive = promotions.filter(
            element =>
              element.active == true &&
              moment(element.end_date).isAfter(moment())
          );
          this.promotionsCanceled = promotions.filter(
            element =>
              element.active == false &&
              moment(element.end_date).isBefore(moment())
          );
          this.paginationActive.totalPages = Math.ceil(
            this.promotionsActive.length / 10
          );
          this.paginationCanceled.totalPages = Math.ceil(
            this.promotionsCanceled.length / 10
          );
        },
        err => {
          console.log(err);
        }
      );
    },

    cancelPromotion(promotionId) {
      this.deletePromotionModal = false;
      this.promotionController.disable(promotionId).then(() => {
        this.$awn.success('Oferta Excluída');
        this.getPromotions();
      });
    },

    isActive(value) {
      return value.active;
    },
    isDisabled(value) {
      return !value.active;
    },

    changePage(status) {
      if (status == 'active') {
        this.activePromotions = true;
        this.canceledPromotions = false;
      }
      if (status == 'canceled') {
        this.activePromotions = false;
        this.canceledPromotions = true;
      }
    },
  },
};
</script>

<style scoped>
.container-principal {
  margin: 0px !important;
  min-width: none !important;
  max-width: none !important;
}
.colorApp {
  background-color: var(--secondary-color) !important;
}
</style>
